var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('LogoSection'),_c('VideoSection'),_c('PitchDeckSection'),_c('YouTubeSection'),_c('SocialLinksSection'),_c('PhotoGallerySection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }